import React ,{useState,useEffect} from 'react'
import { NavLink, useParams } from 'react-router-dom'
import {API_URL} from './context'

const SingleMovie = () => {

    const {id} = useParams();

    const [movie,setMovie] = useState([]);
    const [isError,setIsError]=useState({show:"false",msg:""})
    const [query,setQuery]=useState('avenger')

    const getMovies = async(url)=>{
        try{
             const res= await fetch(url);
             const data=await res.json();
             console.log(data);
             if(data.Response==='True'){
                 setMovie(data)
             }else{
                 setIsError({
                    show:true,
                    msg:data.Error
                 })
             }
        }catch(error){
            console.log(error)
        }
    }
    useEffect(()=>{
       let timerOut= setTimeout(()=>{
            getMovies(`${API_URL}&i=${id}`);
        },400);

        return ()=>clearTimeout(timerOut)
    
    },[query])
    return (
      
            <section className='single-page-section'>
                 <div className='single-card'>
                    <figure>
                        <img src={movie.Poster} />
                    </figure>
                    <div className="card-content">
                        <h3>{movie.Title}</h3>
                        <p>Released : {movie.Released}</p>
                        <p>Genre : {movie.Genre}</p>
                        <p>Rating : {movie.imdbRating} / 10</p>
                        <p>Country : {movie.Country}</p>
                        <p>Language : {movie.Language}</p>
              
                        <NavLink to="/" className="back-btn">
                            Go Back
                        </NavLink>
                        </div>
                 </div>
            </section>
 
    )
}

export default SingleMovie